document.addEventListener('DOMContentLoaded', () => {
  const DEFAULT_LINES = 2;

  const targets = document.querySelectorAll('[data-readmore]');
  targets.forEach((el) => {
    const lines = parseInt(el.getAttribute('data-readmore-lines') || DEFAULT_LINES, 10);
    const moreLabel = el.getAttribute('data-readmore-more') || 'Leer más';
    const lessLabel = el.getAttribute('data-readmore-less') || 'Leer menos';
    const placement = (el.getAttribute('data-readmore-placement') || 'inline').toLowerCase();
    const placeBelow = placement === 'below';

    el.style.setProperty('--rm-lines', String(lines));
    el.classList.add('read-more');

    const btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'read-more__toggle';
    btn.setAttribute('aria-expanded', 'false');
    btn.textContent = moreLabel;

    const wrapper = document.createElement('div');
    wrapper.className = 'read-more__container read-more--collapsed' + (placeBelow ? ' read-more--below' : '');
    el.parentNode.insertBefore(wrapper, el);
    wrapper.appendChild(el);
    wrapper.appendChild(btn);

    const computeOverflow = () => {
      // Measure collapsed height
      el.classList.remove('read-more--expanded');
      const collapsedH = el.getBoundingClientRect().height;
      // Measure full height
      el.classList.add('read-more--expanded');
      const fullH = el.getBoundingClientRect().height;
      el.classList.remove('read-more--expanded');
      return fullH - collapsedH > 1; // allow 1px tolerance
    };

    // Reserve space at the end of the last visible line for the toggle
    const applyCollapsedPadding = () => {
      const gap = 8; // px
      const width = btn.offsetWidth || 0;
      el.style.paddingRight = `${width + gap}px`;
    };

    // Initial compute after button is in DOM
    requestAnimationFrame(() => {
      const overflow = computeOverflow();
      if (!overflow) {
        btn.style.display = 'none';
        wrapper.classList.remove('read-more--collapsed', 'read-more--expanded');
        el.style.paddingRight = '';
        return;
      }
      btn.style.display = '';
      if (!placeBelow && btn.getAttribute('aria-expanded') === 'false') applyCollapsedPadding();
    });

    // Recompute on resize in case of responsive changes
    const onResize = () => {
      const overflow = computeOverflow();
      if (!overflow) {
        btn.style.display = 'none';
        wrapper.classList.remove('read-more--collapsed', 'read-more--expanded');
        el.style.paddingRight = '';
        return;
      }
      btn.style.display = '';
      if (!placeBelow && btn.getAttribute('aria-expanded') === 'false') {
        applyCollapsedPadding();
      } else {
        el.style.paddingRight = '';
      }
    };
    window.addEventListener('resize', onResize);

    btn.addEventListener('click', () => {
      const expanded = btn.getAttribute('aria-expanded') === 'true';
      const next = !expanded;
      btn.setAttribute('aria-expanded', String(next));
      el.classList.toggle('read-more--expanded', next);
      wrapper.classList.toggle('read-more--collapsed', !next);
      wrapper.classList.toggle('read-more--expanded', next);
      btn.textContent = next ? lessLabel : moreLabel;
      if (next) {
        el.style.paddingRight = '';
      } else {
        applyCollapsedPadding();
      }
    });
  });
});


